import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import BaseController from 'uplisting-frontend/pods/base/controller';
import { animatedTransition } from 'uplisting-frontend/utils/router';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ProtectionDisputesDisputeController extends BaseController {
  @tracked dispute!: ModelRegistry['dispute'];

  @action
  handleClose(): void {
    animatedTransition(() => this.router.transitionTo('protection.disputes'));
  }
}
